import { UserRoleType } from '@/dashboard/types/user_role';

export default function getRoleEmoji(role: UserRoleType): string {
  switch (role) {
    case 'owner':
      return '👑';
    case 'admin':
      return '🎛️';
    case 'creator':
      return '🖼';
    case 'viewer':
      return '👀';
    case 'client':
      return '💼';
  }
}
